export enum EBillsStatuses {
  ACTIVE='active',
  INACTIVE='inactive',
  PENDING='pending',
}
